export const FORM_ID = 'ProfileGoals--Estate-Planning';

export const UPSERT_GOAL_URL = '/Consumer/GoalUpdate/SaveEstatePlanningGoal';

export interface EstatePlanningGoalData {
  hasEstatePlanningDocuments: boolean;
}

interface PersonDeductionsAndGiftsDTO {
  administrationExpenseDeductionAmount: number;
  lifetimeGiftingExemptionUsedAmount: number;
}

interface DeductionsAndGiftsDTO {
  principalDeductionsAndGifts: PersonDeductionsAndGiftsDTO;
  spouseDeductionsAndGifts: PersonDeductionsAndGiftsDTO | null;
}

interface EstatePlanningDetailsDTO {
  deductionsAndGifts: DeductionsAndGiftsDTO;
  spouseTaxFilingState: number;
}

export interface EstatePlanningGoalDataDTO {
  hasEstatePlanningDocuments: boolean;
  hasSpouse: boolean;
  estatePlanningDetails: EstatePlanningDetailsDTO;
  principalTaxFilingState: number;
}

export interface FormValues {
  assetBucketingIndices: number[];
  principalTaxFilingState: number;
  spouseTaxFilingState: number;
  deductionsAndGifts: DeductionsAndGiftsDTO;
}
